const faqs = [
  {
    question: "Does Colorado have its own regional passport agency?",
    answer:
      "Yes. Colorado is home to the Colorado Passport Agency, located at 7245 S Havana Street Suite B-600, Centennial, CO 80112. This agency serves travelers with life-or-death emergencies or international travel within 14 days. However, appointments are extremely limited and often booked weeks in advance. Most Colorado travelers find that using an approved courier service like Fast Passport Center is faster and more convenient.",
  },
  {
    question: "How fast can I get a passport in Colorado?",
    answer:
      "With Fast Passport Center's courier service, Colorado travelers can receive a passport in as little as 24 hours. Our standard expedited service ranges from 3 to 9 business days. Routine processing through the post office typically takes 6 to 13 weeks. Denver-area residents may also try the Colorado Passport Agency for same-day emergency service, but appointments are required and availability is limited.",
  },
  {
    question: "Do I need to visit a passport acceptance facility in Colorado?",
    answer:
      "First-time applicants, minors, and those replacing lost or stolen passports must visit an acceptance facility (typically a post office, county clerk, or public library). Renewals for adults can usually be done by mail without an in-person visit. Colorado has acceptance facilities across the Front Range, Western Slope, and mountain communities.",
  },
  {
    question: "Which Colorado airport should I fly from with an expired passport?",
    answer:
      "If your passport is expired or soon to expire, you should not book international travel until you have a valid passport in hand. Major Colorado international airports include Denver International (DEN) and Colorado Springs Airport (COS). Regional mountain airports like Eagle County (EGE), Aspen (ASE), and Durango (DRO) primarily serve domestic routes but connect to international flights through Denver.",
  },
  {
    question: "Can I renew by mail from Colorado?",
    answer:
      "Yes. If your most recent passport was issued when you were 16 or older, is undamaged, was issued within the last 15 years, and was issued in your current name (or you have legal documentation of a name change), you can renew by mail using Form DS-82. Colorado residents can mail their renewal application to the National Passport Processing Center using overnight shipping for faster turnaround.",
  },
  {
    question: "Where is the best place to get a passport photo in Colorado?",
    answer:
      "CVS, Walgreens, and UPS Store locations are widely available along the Front Range from Fort Collins to Colorado Springs. FedEx Office also offers passport photos at Denver, Boulder, and Colorado Springs locations. Mountain resort towns like Vail, Aspen, and Breckenridge have fewer options — plan ahead or use a mobile photo service if you're in a remote area.",
  },
];

export { faqs };

export default function ColoradoFAQSection() {
  return (
    <section id="faq" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Colorado Passport Questions
          </h2>
          <p className="text-gray-500 text-base leading-relaxed">
            Quick answers for travelers applying for passports across the state of Colorado.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <details
              key={i}
              className="group bg-white rounded-lg border border-gray-200 overflow-hidden"
            >
              <summary className="flex items-center justify-between cursor-pointer p-5 list-none">
                <span className="font-bold text-[#1A365D] text-sm pr-4">{faq.question}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                  <i className="ri-add-line text-[#1A365D] text-sm group-open:ri-subtract-line"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-gray-500 text-sm leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}